export default "__VITE_ASSET__CPc87vKA__"